import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';
import { MpiProviderId, MpiProviderStaticData } from '~/tenants/mpi/model/MpiProvider';
import { DateTime } from 'luxon';

export enum MpiVersion {
  V1 = '2025-06-11T21:18:39.591Z',
}

export function mpi_version(date: TDateISO | DateTime, version: MpiVersion) {
  return (typeof date === 'string' ? new Date(date) : date.toJSDate()) >= new Date(version);
}

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone, addresses and pay live in ./providers.server.ts and are
 * merged into these same objects on the server (tenants/providers.server.ts).
 */
const MPI_PROVIDER_DATA_PUBLIC: Record<MpiProviderId, ProviderPublic<MpiProviderStaticData & ProviderStaticConfig>> = {
  // [MpiProviderId.CHAY_DEAVER]: {
  //   first: 'Chay',
  //   last: 'Deaver',
  //   color: '#B4C79B',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //   expense_photos: 85,
  // },
  // [MpiProviderId.BRAYLAN_DODSON]: {
  //   first: 'Braylan',
  //   last: 'Dodson',
  //   color: '#2EC28E',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //   performable_commercial: true,
  //   performable_walkthrough: true,
  //   performable_floorplan: true,
  //   performable_aerial: true,
  //   performable_3d: true,
  // },
  // [MpiProviderId.STEPHEN_POSKO]: {
  //   first: 'Stephen',
  //   last: 'Posko',
  //   color: '#B4C79B',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //   performable_commercial: true,
  //   performable_walkthrough: true,
  //   performable_aerial: true,
  //   performable_3d: true,
  // },
  [MpiProviderId.SOPHIA_BEDNARIK]: {
    first: 'Sophia',
    last: 'Bednarik',
    color: '#FFEC99',
    headshot: 'avatar.jpg',
    location: 'clb',
    schedule: true,

    performable_event: true,
    performable_headshot: true,
    performable_commercial: true,
    performable_walkthrough: true,
    performable_floorplan: true,
    performable_aerial: true,
    performable_3d: true,
  },
  // [MpiProviderId.NICK_KIPKE]: {
  //   first: 'Nick',
  //   last: 'Kipke',
  //   color: '#B4C79B',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //   performable_walkthrough: true,
  //   performable_floorplan: true,
  // },
  [MpiProviderId.ALEX_GREGORY]: {
    first: 'Alexandra',
    last: 'Gregory',
    color: '#CDB0D8',
    headshot: 'avatar.jpg',
    location: 'clb',
    schedule: true,


    performable_event: true,
    performable_commercial: true,
    performable_floorplan: true,
    performable_aerial: true,
  },
  // [MpiProviderId.BRIAN_WOODS]: {
  //   first: 'Brian',
  //   last: 'Woods',
  //   color: '#B4C79B',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //   performable_walkthrough: true,
  //   performable_floorplan: true,
  //   performable_3d: true,
  // },
  // [MpiProviderId.DAN_WEINEL]: {
  //   first: 'Dan',
  //   last: 'Weinel',
  //   color: '#A0DAE0',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //
  //   performable_commercial: true,
  //   performable_walkthrough: true,
  //   performable_floorplan: true,
  //   performable_aerial: true,
  //   performable_3d: true,
  // },
  [MpiProviderId.NIK_TYLER]: {
    first: 'Nik',
    last: 'Tyler',
    color: '#B4C79B',
    headshot: 'avatar.jpg',
    location: 'clb',
    schedule: true,
    performable_floorplan: true,
    performable_aerial: true,
    performable_3d: true,
  },
  // [MpiProviderId.HOULTON_MAHANEY]: {
  //   first: 'Houlton',
  //   last: 'Mahaney',
  //   color: '#3E7EC7',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //
  //   performable_event: true,
  //   performable_headshot: true,
  //   performable_commercial: true,
  //   performable_walkthrough: true,
  //   performable_floorplan: true,
  //   performable_aerial: true,
  //   performable_3d: true,
  // },
  [MpiProviderId.TIFFANY_LANG]: {
    first: 'Tiffany',
    last: 'Roschy-Lang',
    color: '#7CB0B6',
    headshot: 'avatar.jpg',
    location: 'clb',
    schedule: true,
    performable_walkthrough: true,
    performable_floorplan: true,
    performable_aerial: true,
  },
  // [MpiProviderId.MIKE_DAVIS]: {
  //   first: 'Mike',
  //   last: 'Davis',
  //   color: '#B4C79B',
  //   headshot: 'avatar.jpg',
  //   location: 'clb',
  //   schedule: true,
  //   expense_photos: 60,
  //
  //   performable_floorplan: true,
  //   performable_3d: true,
  // },
  [MpiProviderId.PRINT_TEAM]: {
    first: 'Print',
    last: 'Team',
    headshot: 'avatar.jpg',
    location: 'clb',
  },
  [MpiProviderId.PURE_COLOR]: {
    first: 'Pure',
    last: 'Color',
    headshot: 'avatar.jpg',
    location: 'clb',
    editor: true,
  },
  [MpiProviderId.KATHLEEN_KASTE]: {
    first: 'Kathleen',
    last: 'Kaste',
    headshot: 'avatar.jpg',
    location: 'clb',
    schedule: true,
    color: '#FF0000',
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const MPI_PROVIDER_DATA = MPI_PROVIDER_DATA_PUBLIC as Record<MpiProviderId, MpiProviderStaticData & ProviderStaticConfig>;
